import "core-js/modules/es6.object.freeze";

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export var MODE = Object.freeze({
  radio: 'radio',
  checkbox: 'checkbox'
});
export var STATE_CHANGE_TYPE = Object.freeze({
  change: 'change'
});